import React, { useCallback } from 'react';

/**
 * ズームレベルを管理するカスタムフック。
 *
 * @typedef {Object} ZoomHook
 * @property {number} zoomLevel - 現在のズームレベル
 * @property {function(): void} handleZoomIn - ズームインを処理する関数
 * @property {function(): void} handleZoomOut - ズームアウトを処理する関数
 *
 * @function
 * @param {number} initialZoom - 初期のズームレベル。
 * @param {number} minZoom - ズームレベルの最小値
 * @param {number} maxZoom - ズームレベルの最大値
 * @param {number} step - ズームイン/アウト時の増減値
 * @returns {ZoomHook} - ズーム関連の状態と操作関数
 */
const useZoom = (initialZoom, minZoom, maxZoom, step) => {
  const [zoomLevel, setZoomLevel] = React.useState(initialZoom);

  const handleZoomIn = useCallback(() => {
    if (zoomLevel < maxZoom) {
      setZoomLevel(prevZoom => prevZoom + step);
    }
  }, [zoomLevel, maxZoom, step]);

  const handleZoomOut = useCallback(() => {
    if (zoomLevel > minZoom) {
      setZoomLevel(prevZoom => prevZoom - step);
    }
  }, [zoomLevel, minZoom, step]);

  return { zoomLevel, handleZoomIn, handleZoomOut };
};

export default useZoom;
